import { render, staticRenderFns } from "./DialogResourceSubDayOff.vue?vue&type=template&id=4b112958&"
import script from "./DialogResourceSubDayOff.vue?vue&type=script&lang=js&"
export * from "./DialogResourceSubDayOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports